// Sections
import Hero from "./sections/Hero";

// Schema

// Styles
import SEO from "../SEO";
import "./Projects.css";
import ProjectGrid from "./sections/ProjectGrid";
import TechnologiesUsed from "./sections/TechnologiesUsed";
import Testimonials from "./sections/Testimonials";
import ProjectsFAQ from "./sections/FAQ";
import CTA from "./sections/CTA";

const Projects = () => {
  return (
    <>
      {/* ================= SEO ================= */}
      <SEO
        title="Our Projects | Web & App Development Portfolio – Oglitz"
        description="Explore Oglitz’s portfolio of web, mobile, and software development projects. We build scalable, secure, and high-performance digital products for startups and enterprises."
        url="https://www.oglitz.com/project"
        // schemaData={projectsPageSchema}
      />

      {/* ================= PAGE CONTENT ================= */}
      <main className="oglitz-projects-page">
        <Hero />
        <ProjectGrid />
        <TechnologiesUsed />
        <Testimonials />
        <ProjectsFAQ />
        <CTA />
      </main>
    </>
  );
};

export default Projects;
